"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMove = applyMove;
var constants_1 = require("@/constants");
//import { initStartingBoard, initBoard } from "./board";
/**
 * Creates a game state with checkers at the specified positions and optional bar/off counts.
 *
 * @param whitePositions - Array of board indices where white checkers should be placed
 * @param blackPositions - Array of board indices where black checkers should be placed
 * @param whiteBar - Number of white checkers on the bar (default: 0)
 * @param blackBar - Number of black checkers on the bar (default: 0)
 * @param whiteOff - Number of white checkers borne off (default: 0)
 * @param blackOff - Number of black checkers borne off (default: 0)
 * @param currentPlayer - The current player (default: white)
 * @returns A complete game state
 */
/*
export function initState(
  gameId: string,
  whitePositions: number[] = [],
  blackPositions: number[] = [],
  whiteBar: number = 0,
  blackBar: number = 0,
  whiteOff: number = 0,
  blackOff: number = 0,
  moves: AtomicMove[] = [],
  sequence: number = 0,
  currentPlayer: Player = PLAYER_WHITE,
): GameState {
  return {
    gameId: gameId,
    board: initBoard(whitePositions, blackPositions),
    bar: { white: whiteBar, black: blackBar },
    off: { white: whiteOff, black: blackOff },
    currentPlayer,
    moves: moves,
    sequence: sequence,
    dice: [],
  };
}
*/
/**
 * Creates a standard starting game state for backgammon.
 *
 * @returns A game state with the standard starting position
 */
/*
export function initStartingState(player: Player = PLAYER_WHITE): GameState {
  return {
    board: initStartingBoard(),
    bar: { white: 0, black: 0 },
    off: { white: 0, black: 0 },
    currentPlayer: player,
    moves: [],
    sequence: 0,
    dice: [],
  };
}
*/
/**
 * Applies a single move to a game state, returning a new copy of the game state.
 *
 * @param gameState - The game state to modify
 * @param move - The atomic move to apply
 * @returns a new copy of the game state
 */
function applyMove(playerColor, gameState, move) {
    var from = move.from, to = move.to;
    var opponent = playerColor === constants_1.PLAYER_WHITE ? constants_1.PLAYER_BLACK : constants_1.PLAYER_WHITE;
    var clonedGameState = structuredClone(gameState);
    // Handle movement from the bar
    if (from === constants_1.BAR_INDEX_WHITE || from === constants_1.BAR_INDEX_BLACK) {
        // Decrement the appropriate bar counter
        if (playerColor === constants_1.PLAYER_WHITE) {
            clonedGameState.bar.white--;
        }
        else {
            clonedGameState.bar.black--;
        }
    }
    else {
        // Remove checker from source point
        clonedGameState.board[from].count--;
        if (clonedGameState.board[from].count === 0) {
            clonedGameState.board[from].player = null;
        }
    }
    // Handle bearing off
    if (to === constants_1.OFF_INDEX_WHITE || to === constants_1.OFF_INDEX_BLACK) {
        // Increment the appropriate off counter
        if (playerColor === constants_1.PLAYER_WHITE) {
            clonedGameState.off.white++;
        }
        else {
            clonedGameState.off.black++;
        }
    }
    // Handle regular move or hitting opponent
    else {
        var targetPoint = clonedGameState.board[to];
        // If hitting opponent's blot, move it to the bar
        if (targetPoint.player === opponent && targetPoint.count === 1) {
            if (opponent === constants_1.PLAYER_WHITE) {
                clonedGameState.bar.white++;
            }
            else {
                clonedGameState.bar.black++;
            }
            // Clear the point for our checker
            targetPoint.count = 0;
            targetPoint.player = null;
        }
        // Place our checker on the target point
        if (targetPoint.count === 0) {
            targetPoint.player = playerColor;
            targetPoint.count = 1;
        }
        else {
            targetPoint.count++;
        }
    }
    return clonedGameState;
}
//# sourceMappingURL=state.js.map